<div 
     aria-atomic="true" class="{{cid}}_feedback_blocks feedback__blocks {{feedbackState}} {{class}}"
     {{#if enable_focus}}tabindex="0"{{/if}} data-action-target="feedback" data-action-type="{{feedbackState}}" data-block= "result"
     >
</div>
